import { observer } from 'mobx-react';

import { useTournamentWidgetData } from '../../hooks/useTournamentWidgetData';
import type { TournamentWidgetDataType, WidgetSizeType } from '../../types';
import { WidgetWrapper } from '../WidgetWrapper/WidgetWrapper';

import { TournamentSmallWidget } from './TournamentSmallWidget/TournamentSmallWidget';
import { TournamentWideWidget } from './TournamentWideWidget/TournamentWideWidget';
import { TournamentWidgetTimer } from './TournamentWidgetTimer/TournamentWidgetTimer';

interface TournamentWidgetProps {
  sizeType: WidgetSizeType;
  data: TournamentWidgetDataType;
}

function TournamentWidgetComponent(props: TournamentWidgetProps) {
  const { data, sizeType } = props;
  const { event } = data;

  const {
    widgetImageUrl,
    leaderboard,
    startDate,
    endDate,
    isTournamentUpcoming,
    positionValue,
    onTimerEnd,
    handleClick,
  } = useTournamentWidgetData({ event });

  if (!leaderboard) {
    return null;
  }

  const timer = (
    <TournamentWidgetTimer
      endDate={endDate}
      extended={sizeType === 'wide'}
      noPosition={positionValue === null}
      startDate={startDate}
      to={isTournamentUpcoming ? 'start' : 'end'}
      onEnd={onTimerEnd}
    />
  );

  return (
    <WidgetWrapper smallWidgetExtended dataTestId={data.dataTestId} sizeType={sizeType} onClick={handleClick}>
      {sizeType === 'small' ? (
        <TournamentSmallWidget positionValue={positionValue} timer={timer} widgetImageUrl={widgetImageUrl} />
      ) : (
        <TournamentWideWidget positionValue={positionValue} timer={timer} widgetImageUrl={widgetImageUrl} />
      )}
    </WidgetWrapper>
  );
}

export const TournamentWidget = observer(TournamentWidgetComponent);
